import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Footer from "../components/Footer";
import "./Properties.css";
import { IoLocationOutline } from "react-icons/io5";
import { LuBedSingle } from "react-icons/lu";
import { CiRuler } from "react-icons/ci";
import { MdAttachMoney } from "react-icons/md";

const Properties = () => {
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    category: "",
    city: "",
    type: "",
    minPrice: "",
    maxPrice: "",
    search: "",
  });

  // Scroll to top عند فتح الصفحة
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    fetchProperties();
  }, [filters]);

  const fetchProperties = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams();
      Object.keys(filters).forEach((key) => {
        if (filters[key]) params.append(key, filters[key]);
      });
      const response = await axios.get(`/api/properties?${params.toString()}`);
      setProperties(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching properties:", error);
      setLoading(false);
    }
  };

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const clearFilters = () => {
    setFilters({
      category: "",
      city: "",
      type: "",
      minPrice: "",
      maxPrice: "",
      search: "",
    });
  };

  return (
    <div className="properties-page">
      <div className="container">
        <h1 className="page-title">جميع العقارات</h1>

        {/* Filters */}
        <div className="filters-panel">
          <div className="filter-row">
            <input
              type="text"
              name="search"
              placeholder="ابحث بالكلمات المفتاحية..."
              value={filters.search}
              onChange={handleFilterChange}
              className="search-input"
            />
          </div>
          <div className="filter-row">
            <select
              name="type"
              value={filters.type}
              onChange={handleFilterChange}
            >
              <option value="">نوع الإعلان</option>
              <option value="buy">للبيع</option>
              <option value="rent">للإيجار</option>
            </select>
            <select
              name="category"
              value={filters.category}
              onChange={handleFilterChange}
            >
              <option value="">نوع العقار</option>
              <option value="شقة">شقة</option>
              <option value="منزل">منزل</option>
              <option value="أرض">أرض</option>
              <option value="مكتب">مكتب</option>
              <option value="متجر">متجر</option>
              <option value="مستودع">مستودع</option>
            </select>
            <select
              name="city"
              value={filters.city}
              onChange={handleFilterChange}
            >
              <option value="">المدينة</option>
              <option value="دمشق">دمشق</option>
              <option value="حلب">حلب</option>
              <option value="حمص">حمص</option>
              <option value="حماة">حماة</option>
              <option value="اللاذقية">اللاذقية</option>
              <option value="طرطوس">طرطوس</option>
            </select>
            <input
              type="number"
              name="minPrice"
              placeholder="أقل سعر"
              value={filters.minPrice}
              onChange={handleFilterChange}
            />
            <input
              type="number"
              name="maxPrice"
              placeholder="أعلى سعر"
              value={filters.maxPrice}
              onChange={handleFilterChange}
            />
            <button onClick={clearFilters} className="btn btn-secondary">
              مسح الفلاتر
            </button>
          </div>
        </div>

        {/* Results Count */}
        {!loading && (
          <div className="results-count">
            <p>تم العثور على {properties.length} عقار</p>
          </div>
        )}

        {/* Properties List */}
        {loading ? (
          <div className="loading">
            <div className="spinner"></div>
          </div>
        ) : properties.length > 0 ? (
          <div className="properties-list">
            {properties.map((property) => (
              <Link
                to={`/property/${property.id}`}
                key={property.id}
                className="property-item"
              >
                <div className="property-image">
                  {property.images && property.images.length > 0 ? (
                    <img
                      src={`/api${property.images[0]}`}
                      alt={property.title}
                    />
                  ) : (
                    <div className="no-image">لا توجد صورة</div>
                  )}
                  <span className="property-type">
                    {property.type === "buy" ? "للبيع" : "للإيجار"}
                  </span>
                </div>
                <div className="property-content">
                  <h3>{property.title}</h3>
                  <p className="property-description">
                    {property.description?.substring(0, 150)}...
                  </p>
                  <div className="property-meta">
                    {property.city && (
                      <span>
                        <IoLocationOutline /> {property.city}
                      </span>
                    )}
                    {property.rooms && (
                      <span>
                        <LuBedSingle /> {property.rooms} غرف
                      </span>
                    )}
                    {property.area && (
                      <span>
                        <CiRuler /> {property.area} م²
                      </span>
                    )}
                    <span>
                      <MdAttachMoney /> {property.price.toLocaleString()} ل.س
                    </span>
                  </div>
                  <div className="property-footer">
                    <span className="property-date">
                      {new Date(property.createdAt).toLocaleDateString("ar-SY")}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        ) : (
          <div className="empty-state">
            <h3>لا توجد عقارات متاحة</h3>
            <p>جرب تغيير معايير البحث أو تحقق مرة أخرى لاحقاً</p>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Properties;
